module.exports = __webpack_public_path__ + "img/product-placeholder-71.6d9acf1.png";